import { useEffect } from "react";

function Modal({ isOpen, onClose, topLink, bottomLink }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      onClick={onClose}
    >
      <div className="fixed inset-0 bg-black/40 backdrop-blur-sm animate-fadeIn" />
      <div
        className="relative z-50 w-full max-w-md mx-4 aspect-[3/4] rounded-lg overflow-hidden animate-fadeIn"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="absolute inset-0 bg-cover bg-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-transparent to-black/80" />
        <div className="absolute inset-0 flex flex-col justify-between p-6">
          <a
            href={topLink}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full h-1/2 rounded-lg bg-center bg-cover flex items-center justify-center text-white text-xl font-bold"
            style={{
              color: "white",
              textShadow:
                "1px 0 0 #AA6C39, 0 -1px 0 #AA6C39, 0 1px 0 #AA6C39, -1px 0 0 #AA6C39",
              marginBottom: "1rem",
              backgroundImage: "url(/puma-shoes.webp)",
              boxShadow: "inset 100px 100px 100px rgba(0,0,0,0.5)",
            }}
          >
            AS.ST07RE
          </a>
          <a
            href={bottomLink}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full h-1/2 rounded-lg bg-center bg-cover flex items-center justify-center text-white text-xl font-bold"
            style={{
              color: "white",
              textShadow:
                "1px 0 0 #AA6C39, 0 -1px 0 #AA6C39, 0 1px 0 #AA6C39, -1px 0 0 #AA6C39",
              backgroundImage: "url(/nike-shoes.webp)",
              boxShadow: "inset 100px 100px 100px rgba(0,0,0,0.25)",
            }}
          >
            VAKI SHOES
          </a>
        </div>
      </div>
    </div>
  );
}

export default Modal;
